import Vue from 'vue';
import VueRouter from 'vue-router';
import EidtokenCloud from '../pages/eidtokenCloud/eidtokenCloud.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'eidtokenCloud',
    component: EidtokenCloud,
  },
  {
    path: '/legalConsultingServices',
    name: 'legalConsultingServices',
    component: () => import('../pages/legalConsultingServices/legalConsultingServices.vue'),
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
